import styled from 'styled-components'

export const IconButton = styled.button`
  margin-right: 10px;
  padding: 2px;
  border: none;
  background: none;
  height: 20px;
  cursor: pointer;
  &:focus {
    outline: 4px solid ${(p) => p.theme.uiKit.colors.global.grey.grey700};
  }
`

export const NameRow = styled.span`
  display: flex;
  align-items: center;
`
